class KanbanSimpleLogic {
    columns = [ "To do", "In progress", "Done" ];

    buildRows(requirements) {
        let rows = [];
        if(Array.isArray(requirements)) {
            requirements.forEach(requirement => {
                let column = this.column(requirement.tasks);
                let row = undefined;
                for(var i = 0; i < rows.length && !row; i++) {
                    if(!rows[i][column]) {
                        row = rows[i];
                    }
                }

                if(!row) {
                    row = {};
                    rows.push(row);
                }

                row[column] = requirement;
            });
        } else if(requirements) {
            console.log("KanbanSimpleLogic cannot show requirements:", requirements);
        }
        return rows;
    }

    // TODO Move this logic to the server.
    column(tasks) {
        /*
        If no tasks are done, show it in To do.
        If some tasks are started or done, show it in that column. If the tasks belong to different columns, use the leftmost column.
        If all tasks are done, show it in Done. Remove it from the board when the requirement is set to done.
        */
        if(!tasks) {
            return "...";
        }

        let count = {
            todo: 0,
            todoTest: 0,
            inProgress: 0,
            inProgressTest: 0,
            done: 0,
        };
        tasks.forEach(task => {
            // console.log("KanbanLogic: task status", task.status);
            switch(task.status) {
                case 'To do':
                    if(task.name.startsWith("Test")) {
                        count.todoTest++;
                    } else {
                        count.todo++;
                    }
                    break;
                case 'In progress':
                    if(task.name.startsWith("Test")) {
                        count.inProgressTest++;
                    } else {
                        count.inProgress++;
                    }
                    break;
                case 'Done':
                    count.done++;
                    break;
                default:
                    break;
            }
        });

        if(count.todo === tasks.length) {
            return "To do";
        } else if(count.done === tasks.length) {
            return "Done";
        } else {
            return "In progress";
        }
    }
}

export default KanbanSimpleLogic;